(function () {
 document.addEventListener("DOMContentLoaded", function () {
  const countdownEl = document.querySelector(".fum-countdown-component");
  const countdownContainerEl = document.querySelector(".fum-countdown-container"); 
  const targetDate = new Date(countdownEl.getAttribute("data-countdown-endat")).getTime();

  const daysEl = document.getElementById("days");
  const hoursEl = document.getElementById("hours");
  const minutesEl = document.getElementById("minutes");
  const secondsEl = document.getElementById("seconds");

  let countdownStarted = false; // Track if the countdown has started

  function updateCountdown() {
    const now = Date.now();
    const timeLeft = targetDate - now;

    // Check if countdown has ended
    if (timeLeft <= 0) {
      countdownEl.innerHTML = "<div class='fum-countdown'><h3>Countdown Ended!!</h3></div>";
      return;
    }

    // Set container to flex only once when countdown is active
    if (!countdownStarted) {
      countdownContainerEl.style.display = "flex";
      countdownStarted = true;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24)).toString().padStart(2, "0");
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, "0");
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, "0");
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000).toString().padStart(2, "0");

    daysEl.textContent = days;
    hoursEl.textContent = hours;
    minutesEl.textContent = minutes;
    secondsEl.textContent = seconds;

    requestAnimationFrame(updateCountdown);
  }

  updateCountdown();
});

})();